import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App';
import { attachAuthRefresh } from './services/apiClient';
import './index.css';

// Give the DEFAULT axios instance the same 401 -> refresh -> retry behaviour
// that apiClient and dashboardService's own instance already had.
//
// Most pages do not use those instances: they call the bare axios module
// directly, e.g. axios.get(url, { headers: authHeaders() }). Those calls never
// passed through any refresh interceptor, so the moment the 30-minute access
// token expired they returned 401 forever. That is what produced "Showing
// last-known data from 47 minutes ago - the latest refresh failed" on the
// Dashboard and "Failed to load cost data" on Cost Explorer, and why Retry /
// Try Again never helped: both re-sent the same dead token.
//
// Instances built with axios.create() do NOT inherit these interceptors, so
// this cannot double-refresh for services that already wrap themselves.
attachAuthRefresh(axios);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
